// DS: MO3.4.4
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import BuyButton from '@wix/da-ds/pkg/Buttons/BuyButton';
import PremiumGalleryIcon from '@wix/da-ds/pkg/Icons/16x16/PremiumGallery';
import VisuallyHidden from '@wix/da-a11y/pkg/components/VisuallyHidden';
import ThumbStatusIndicators from '@wix/da-ds/pkg/thumbs/ThumbStatusIndicators';
import { normalizePremiumFolderData } from '../../utils/normalizePremiumFolderData';
import FolderStats from '../../FolderCard/legos/FolderStats';
import { gallectionTypeToResourceType } from '../../types/gallection';
import ShopCardDumb from '../_partials/ShopCardDumb';
import PriceWithPoints from '../_partials/PriceWithPoints';
import s from './FolderShopCard.scss';
const FolderShopCard = ({ width, folder, withAuthorDetails, withIndicators = true, withUnlockButton })=>{
    const { t } = useTranslation();
    const { isPaidFolder, pointPrice, formattedDollarPrice } = normalizePremiumFolderData(folder === null || folder === void 0 ? void 0 : folder.premiumFolderData);
    let indicatorType = null;
    if (isPaidFolder) {
        indicatorType = 'premium-folder';
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        style: {
            width
        }
    }, /*#__PURE__*/ React.createElement(BiLink, {
        className: s['link'],
        href: Url.userGalleryLink({
            username: folder.owner.username,
            gallectionType: folder.type,
            folderId: folder.folderId,
            folderName: folder.name
        }),
        biData: BiData({
            evid: 100,
            itemid: folder.folderId,
            typeid: gallectionTypeToResourceType(folder.type),
            sectionname: BiContextProvidedValue
        })
    }, /*#__PURE__*/ React.createElement(VisuallyHidden, null, folder.name)), /*#__PURE__*/ React.createElement(ShopCardDumb, {
        width: width,
        coverImage: folder.thumb,
        title: folder.name,
        withAuthorDetails: withAuthorDetails,
        author: folder.owner,
        indicatorsSlot: withIndicators && indicatorType ? /*#__PURE__*/ React.createElement(ThumbStatusIndicators, {
            className: s['indicators'],
            indicators: [
                {
                    type: indicatorType,
                    tooltip: t(`thumb.tooltip.${indicatorType}`)
                }
            ]
        }) : undefined,
        belowCoverImageSlot: /*#__PURE__*/ React.createElement(FolderStats, {
            folder: folder
        }),
        detailsRightSlot: /*#__PURE__*/ React.createElement(PriceWithPoints, {
            formattedDollarsPrice: formattedDollarPrice,
            pointsPrice: pointPrice
        }),
        footerSlot: withUnlockButton && /*#__PURE__*/ React.createElement("div", {
            className: s['footer']
        }, /*#__PURE__*/ React.createElement(BuyButton, {
            size: 'medium',
            variant: "outline",
            rounded: true,
            icon: PremiumGalleryIcon
        }, t('shop.thumb.unlock_premium_gallery')))
    }));
};
FolderShopCard.displayName = 'FolderShopCard';
export default FolderShopCard;
